import script from "./StudentDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./StudentDashboard.vue?vue&type=style&index=0&id=6e2e6ff4&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e2e6ff4"]])

export default __exports__